import type { GetInvoicesResult } from '@features/invoices/api/get-invoices/getInvoices.types';

export const INITIAL_PAGE_SIZE = 25;
export const INITIAL_PAGE_INDEX = 0;
export const INITIAL_INVOICES_DATA: GetInvoicesResult = {
  elements: [],
  total: 0,
};
